// COMPONENTS
import Dropdown from "./dropdown";

const LOGICAL_OPERATORS = [
  { value: "and", label: "AND" },
  { value: "or", label: "OR" },
];

const LogicalOperatorsDropdown = ({ handleChange, value }) => {
  return (
    <Dropdown
      handleChange={handleChange}
      value={value}
      options={LOGICAL_OPERATORS}
    />
  );
};

export default LogicalOperatorsDropdown;
